import { useTranslation } from "react-i18next";

import { IApiError } from "../../../../@types/ApiError";
import { Button } from "../../../../components/Button";
import { WorkflowPublishErrors } from "../WorkflowPublishErrors";
import {
  ModalContainer,
  SubmitContainer,
  Title,
} from "./WorkflowPublishErrorsModal.styles";

type WorkflowPublishErrorsModalProps = {
  errors: IApiError[];
  onClose(): void;
};

export function WorkflowPublishErrorsModal({
  errors,
  onClose,
}: WorkflowPublishErrorsModalProps) {
  const { t } = useTranslation();

  return (
    <ModalContainer>
      <Title>{t("workflows_publishErrors_title")}</Title>

      <WorkflowPublishErrors
        errors={errors}
        title={t("workflows_publishErrors_modalTitle")}
      />

      <SubmitContainer>
        <Button
          label={t("workflows_publishErrors_gotIt")}
          type="button"
          onClick={onClose}
        />
      </SubmitContainer>
    </ModalContainer>
  );
}

export default WorkflowPublishErrorsModal;
